<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="供应商/联系人/电话等" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="供应商类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.b_id"  clearable filterable  placeholder="主营产品">
                                        <Option :value="item.b_id" v-for="(item,index) in businessList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.saler_id"  clearable filterable  placeholder="业务员">
                                        <Option :value="item.admin_id" v-for="(item,index) in salerList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.level"  clearable filterable  placeholder="供应商等级">
                                        <Option :value="item.id" v-for="(item,index) in levelList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="3" >开启</Option>
                                        <Option :value="2" >禁用</Option>
                                        <Option :value="1" >审核</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建供应商</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" @on-selection-change="tableCheckAll" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #company="{ row }">
                                    <div @click="showData(row.company_id)" class="d-width text-primary cursor" :title="row.company">
                                        <span>{{row.company}}</span>
                                    </div>
                                </template>
                                <template #business="{ row }">
                                    <div class="d-width">
                                        <Tag v-for="(item,index) in row.business_list" :key="index">{{item.name}}</Tag>
                                    </div>
                                </template>
                                <template #name="{ row }">
                                    <div class="d-width" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #mobile="{ row }">
                                    <div class="d-width" :title="row.mobile">
                                        <span>{{row.mobile}}</span>
                                    </div>
                                </template>
                                <template #buyer_money="{ row }">
                                    <div class="d-width" :title="row.buyer_money?row.buyer_money:'0.00'">
                                        <span class="text-primary">{{row.buyer_money?row.buyer_money:'0.00'}}</span>
                                    </div>
                                </template>
                                <template #pay_money="{ row }">
                                    <div class="d-width" :title="row.pay_money?row.pay_money:'0.00'">
                                        <span class="text-success">{{row.pay_money?row.pay_money:'0.00'}}</span>
                                    </div>
                                </template>
                                <template #level="{ row }">
                                    <Tag color="orange">{{row.level}}级</Tag>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" status="processing" text="审核" />
                                    <Badge v-else-if="row.status === 2" status="error" text="禁用" />
                                    <Badge v-else-if="row.status === 3" status="success" text="开启" />
                                    <Badge v-else status="warning" text="其他" />
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-success" @click="billData(row.company_id, row.company)">账单</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-primary" @click="editData(row.company_id)">编辑</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-999" @click="delData(row.company_id , index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page">
                                <div class="em-page-btn">
                                    <span class="text-999">选中 <em class="text-danger">{{selectCount}}</em> 条记录</span>
                                    <Divider type="vertical" />
                                    <span class="text-999 mr10">批量</span>
                                    <ButtonGroup size="default">
                                        <Button @click="allDelData()" >删除</Button>
                                    </ButtonGroup>
                                </div>
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 客户账单统计  -->
                    <bill-modal v-if="is_bill" ref="BillRef"></bill-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getCompanyList, getCompanyConfig, deleteCompany, deleteAllCompany} from '@/apis/company'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./Create";
import ShowModal from "./Show";
import BillModal from "./Bill.vue";
export default {
    name: "CompanyIndex",
    components: {
        Headers, Side, AddModal, ShowModal, BillModal
    },
    data () {
        return {
            typeList: [],
            businessList: [],
            levelList: [],
            salerList: [],

            search: {
                name: '',
                type_id: '',
                b_id: '',
                saler_id: '',
                level: '',
                status: '',
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    type: 'selection',
                    width: 55,
                    align: 'center',
                    fixed : 'left'
                },
                {
                    title: '供应商名称',
                    key: 'company',
                    slot: 'company'
                },
                {
                    title: '主营产品',
                    key: 'business',
                    slot: 'business',
                },
                {
                    title: '联系人',
                    key: 'name',
                    slot: 'name',
                    width: 120
                },
                {
                    title: '电话',
                    key: 'mobile',
                    slot: 'mobile',
                    width: 140
                },
                {
                    title: '采购金额',
                    key: 'buyer_money',
                    slot: 'buyer_money',
                    width: 120
                },
                {
                    title: '支付金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                    width: 120
                },
                {
                    title: '类型',
                    key: 'type_name',
                    width: 120
                },
                {
                    title: '等级',
                    key: 'level',
                    slot: 'level',
                    width:100
                },
                {
                    title: '状态',
                    key: 'status',
                    slot : 'status',
                    width:100
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    align: 'center',
                    width : 150,
                    fixed : 'right'
                }
            ],
            is_create : false,
            is_show : false,
            is_transfer : false,
            is_bill : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {

        /**
         功能：账单
         time: 2025/12/16 10:41
         **/
        billData(id, company){
            let that = this;
            that.is_bill = true;
            setTimeout(function(){
                that.$refs.BillRef.show(id, company);
            })
        },
        /**
         功能：搜索
         time: 2025-15-02 16:15:50
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：刷新
         time: 2025-17-02 16:17:18
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                type_id: '',
                b_id: '',
                saler_id: '',
                level: '',
                status: '',
            };
            that.getList();
        },
        /**
         功能：
         time: 2025-59-03 14:59:45
         **/
        getConfig(){
            let that = this;
            getCompanyConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.businessList = e.data.businessList ?? [];
                that.levelList = e.data.levelList ?? [];
                that.salerList = e.data.salerList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getCompanyList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：创建
         time: 2025-26-02 09:26:21
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑
         time: 2025-26-02 09:26:29
         **/
        editData(company_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(company_id);
            })
        },

        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },

        /**
         功能：
         time: 2025/12/15 17:26
         **/
        showData(company_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(company_id);
            })
        },
        /**
         功能：
         time: 2025-37-03 10:37:14
         **/
        tableCheckAll(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            that.selectCount = data.length;
        },
        /**
         功能：删除
         time: 2025-01-02 12:01:16
         **/
        delData(company_id){
            let that = this;
            if(!company_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteCompany(company_id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.getList();
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：
         time: 2025/12/16 11:46
         **/
        allDelData(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            if(data.length <= 0){
                that.$Message.error({ background: true, content:'至少选择一条记录'});
                return false;
            }
            let companyIds = [];
            for(var i  = 0; i < data.length; i++ ){
                companyIds.push(data[i].company_id);
            }
            if(companyIds.length > 0){
                this.$Modal.confirm({
                    title: '批量删除记录',
                    content: '此操作将批量删除记录不可恢复, 是否继续?',
                    onOk: () => {
                        deleteAllCompany(companyIds).then( e =>{
                            that.$Message.success({ background: true,duration:3, content:e.msg});
                            that.getList();
                        })
                    },
                    onCancel: () => {}
                });
            }
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
